import PageTypeFactory from '../../../page/get_page_type';
import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

export const openMobileNavigation = () => {
    const category = GA_EVENTS.navigation.category;
    const action = GA_EVENTS.navigation.actions.openMobile;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
};
